import { Antecedente } from '../../../models/antecedente.model';
import { Component, ViewChild, ElementRef, OnInit, TemplateRef, ChangeDetectorRef, Input, AfterViewInit, AfterContentInit, DoCheck, AfterViewChecked } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
import { getDocuments } from 'src/app/services/getDocuments.service';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';


declare var jQuery: any;
declare var $: any;



@Component({
    selector: "page-antecedentes",
    templateUrl: "./antecedentes.component.html",
    styleUrls: ["./antecedentes.component.css"],
    providers: [FormService]
})



export class AntecedentesComponent implements AfterViewChecked {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;
    @ViewChild('openModalNODOC') openModalNODOC: TemplateRef<any>;
    @ViewChild('openModalNOVALID') openModalNOVALID: TemplateRef<any>;





    public generico = GLOBAL.generico;
    public rows = [];
    public newRows = [];
    public rowsResp = [];
    public rowsResp2 = [];
    public docs = [];
    displayedColumns: string[] = ['nombre'];
    dataSource
    public doc
    public actualRow;
    public antecedente: Antecedente;
    public form;
    public temp_ant;
    public tipo_permiso = new FormControl('', [Validators.required]);
    public maxDate;
    public selected;
    public fecha: string;
    public documentoNombre = ''
    public formulario
    public tipoDoc
    public tipoDocAnt
    public tipo
    docsDetectChange = new BehaviorSubject([])
    solicitud
    storePat
    bandera
    maxMaterias = 0
    seleccion = []



    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private _docs: getDocuments,
        private cd: ChangeDetectorRef,

    ) {
        this.maxDate = moment().toDate()




        if (!JSON.parse(localStorage.getItem("antecedentes"))) {
            localStorage.setItem("antecedentes", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("antecedentes"));

        }
        if (this.generico == true) {

            if (!JSON.parse(localStorage.getItem("ante"))) {
                localStorage.setItem("ante", JSON.stringify(this.rows));
            } else {
                this.rows = JSON.parse(localStorage.getItem("ante"));

            }
        }

        this.antecedente = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 };
        this.temp_ant = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 };

        this.form = new FormGroup({
            tipo_permiso: new FormControl(''),
            permiso: new FormControl(''),
            numero: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)]),
            fecha: new FormControl({ value: '', disabled: true }),
            superficie: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)])
        })

        // this.dialogform = new FormGroup({
        //     numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
        // })

        // this.form.controls['tipo_permiso'].setValue(this.rows[0] ? this.rows[0].tipo_permiso : '')
        // this.form.controls['permiso'].setValue(this.rows[0] ? this.rows[0].permiso : '')
        // this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '')
        // this.form.controls['fecha'].setValue(this.rows[0] ? new Date(this.rows[0].fecha) : null)
        // this.form.controls['superficie'].setValue(this.rows[0] ? this.rows[0].superficie : '')

        this.formulario = localStorage.getItem("formId")
        this.tipoDoc = localStorage.getItem("tipo_sol");
    }

    ngAfterContentInit() {

        this.formulario = localStorage.getItem("formId")
    }

    ngAfterViewChecked() {
        var sol = localStorage.getItem("tipo_solOK");

        if (sol == "cambiado") {
            localStorage.setItem("tipo_solOK", "listo")

            var x = JSON.parse(localStorage.getItem("tipo_sol"));
            if (this.tipoDoc || x) {
                if (this.tipoDoc != x) {
                    this.tipoDoc = JSON.parse(localStorage.getItem("tipo_sol"));
                    /* this.documents() */
                    this.documents2()
                }
            }
        }



    }

    removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    documents2() {
        this.rows = []
        var cont = 0
        this._docs.getDocs().subscribe(
            data => {
                this.doc = data;
                this.solicitud = this.tipoDoc

                for (let index = 0; index < this.doc.length; index++) {
                    if (this.doc[index].Cod == this.formulario) {
                        this.doc = this.doc[index];
                        for (let i = 0; i < this.doc.Materias.length; i++) {
                            const docsMaterias = this.doc.Materias[i]


                            for (let j = 0; j < this.solicitud.length; j++) {
                                const elementSolicitud = this.solicitud[j];

                                if (docsMaterias.Nombre == elementSolicitud) {
                                    for (let k = 0; k < docsMaterias.Docs.length; k++) {
                                        const docSolicitud = docsMaterias.Docs[k];
                                        this.seleccion.push(docSolicitud)

                                    }
                                }
                            }
                        }
                    }
                }

                let sinRepetidos = this.seleccion.filter((valorActual, indiceActual, arreglo) => {
                    return arreglo.findIndex(valorDelArreglo => JSON.stringify(valorDelArreglo) === JSON.stringify(valorActual)) === indiceActual
                });

                let sinRepetidos2 = this.seleccion.filter((valorActual, indiceActual, arreglo) => {
                    return arreglo.findIndex(valorDelArreglo =>
                        JSON.stringify(valorDelArreglo).includes(JSON.stringify(valorActual))) === indiceActual
                });

       

                var uniqueArray = this.removeDuplicates(this.seleccion, "Documento Requerido");


                for (let p = 0; p < uniqueArray.length; p++) {
                    const documentos = uniqueArray[p];

                    this.rows.push({ id: cont, name: documentos["Documento Requerido"], required: documentos.obligatorio })
                    cont++

                }

                this.dataSource = this.rows


                localStorage.setItem("docs_checked", JSON.stringify(this.rows))
                this.docsDetectChange.next(this.dataSource)
                this.cd.detectChanges();
            }, error => {
                console.log(error)
            })
    }


    documents() {
       
        this.rows = []
        this.newRows = []
        this.dataSource = []


        this.solicitud = this.tipoDoc
        this.maxMaterias
        if (this.maxMaterias = 0) {
            this.maxMaterias = this.solicitud.length
        } else {
            if (this.maxMaterias < this.solicitud.length) {

            }
        }

        var cont = 0
        this._docs.getDocs().subscribe(
            data => {
                this.doc = data;
                var cont = 0
                var mayor
                var menor
                for (let index = 0; index < this.doc.length; index++) {
                    if (this.doc[index].Cod == this.formulario) {
                        this.doc = this.doc[index];

                        for (let i = 0; i < this.doc.Materias.length; i++) { //arrglo de 2
                            const docsMaterias = this.doc.Materias[i]
                    

                            for (let j = 0; j < this.solicitud.length; j++) {
                                const elementSolicitud = this.solicitud[j];

                                if (docsMaterias.Nombre == elementSolicitud) {
                                    this.newRows = []

                                    if (this.rowsResp.length > 0) {
                                        cont = this.rowsResp.length

                                        if (this.rowsResp.length >= docsMaterias.Docs.length) {
                                            mayor = this.rowsResp
                                            menor = docsMaterias.Docs
                                        } else {
                                            mayor = docsMaterias.Docs
                                            menor = this.rowsResp
                                        }


                                        for (let x = 0; x < mayor.length; x++) {
                                            const docsMayor = mayor[x];

                                            for (let y = 0; y < menor.length; y++) {
                                                const docsMenor = menor[y];

                                                if (docsMayor["Documento Requerido"]) {

                                                    var large
                                                    var small
                                                    if (docsMayor["Documento Requerido"].length > docsMenor.name.length) {
                                                        large = docsMayor["Documento Requerido"]
                                                        small = docsMenor.name
                                                    } else {
                                                        large = docsMenor.name
                                                        small = docsMayor["Documento Requerido"]
                                                    }

                                                    if (large.includes(small)) {

                                                        if (docsMayor.obligatorio == true) {
                                                            this.rowsResp[y].required == true
                                                        }
                                                        y = menor.length
                                                    } else {
                                                        /* final del array menor */
                                                        if (y + 1 == menor.length) {
                                                            this.newRows.push({ id: cont, name: docsMayor["Documento Requerido"], required: docsMayor.obligatorio })
                                                            cont++
                                                        }
                                                    }

                                                }
                                                if (docsMayor.name) {

                                                    var large
                                                    var small
                                                    if (docsMayor.name.length > docsMenor["Documento Requerido"].length) {
                                                        large = docsMayor.name
                                                        small = docsMenor["Documento Requerido"]
                                                    } else {
                                                        large = docsMenor["Documento Requerido"]
                                                        small = docsMayor.name
                                                    }

                                                    if (large.includes(small)) {
                                                        if (docsMayor.required == true) {
                                                            this.rowsResp[y].required == true
                                                        }
                                                        y = menor.length
                                                    } else {
                                                        if (y + 1 == menor.length) {
                                                            this.newRows.push({ id: cont, name: docsMayor.name, required: docsMayor.required })
                                                            console.log(x, this.newRows)
                                                            cont++
                                                        }

                                                    }
                                                }
                                            }

                                        }

                                    } else {


                                        for (let p = 0; p < docsMaterias.Docs.length; p++) {
                                            const documentos = docsMaterias.Docs[p];

                                            this.rows.push({ id: cont, name: documentos["Documento Requerido"], required: documentos.obligatorio })
                                            cont++

                                        }
                                    }
                                }

                            }




                        }
                    }
                }


                if (this.rowsResp.length > 0) {
                    console.log(this.rowsResp)
                    this.rows = this.rowsResp.concat(this.newRows)
                }
                this.rowsResp = this.rows
                console.log("rows final?", this.rows)
                console.log("nuevas filas", this.newRows)


                this.dataSource = this.rows


                localStorage.setItem("docs_checked", JSON.stringify(this.rows))
                console.log(this.dataSource)
                this.docsDetectChange.next(this.dataSource)
                this.cd.detectChanges();
            },
            error => {
                console.log(error)
            })

    }

    add_docs() {
        this.dialog.open(this.openModalNODOC);
    }

    add() {
        console.log(this.documentoNombre)
        this.docs.push(this.documentoNombre)
        console.log(this.docs)

        /*   this.rows = JSON.parse(this.actualRow); */

        this.rows = this.rows.concat({
            nombre: this.documentoNombre,
        })
        console.log(this.rows)
        localStorage.setItem("ante", JSON.stringify(this.rows));
        this.documentoNombre = ''
    }

    delete_docs(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);

            }
        }
        console.log(this.rows)
        localStorage.setItem("ante", JSON.stringify(this.rows));
    }

    add_antecedentes() {

        //si no tiene informacion...
        if (this.form.get('fecha').value) {
            this.fecha = moment(this.form.get('fecha').value).format('DD/MM/YYYY')
        } else {
            this.fecha = '';
        }

        this.actualRow = localStorage.getItem("antecedentes");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.tipo_permiso && !this.form.value.permiso && !this.form.value.numero && !this.form.value.fecha && !this.form.value.superficie) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);

        } else if (this.form.controls['numero'].hasError('pattern') || this.form.controls['superficie'].hasError('pattern')) {
            console.log("ingresó datos incorrectos");
            this.dialog.open(this.openModalNOVALID);

        } else {

            this.rows = this.rows.concat({
                tipo_permiso: this.form.value.tipo_permiso,
                permiso: this.form.value.permiso,
                numero: this.form.value.numero,
                fecha: this.fecha,
                superficie: this.form.value.superficie
            })

            console.log(this.rows);

            localStorage.setItem("antecedentes", JSON.stringify(this.rows));
            this.form.reset();

        }


    }
    delete_antecedentes(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("antecedentes", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("antecedentes");
        this.rows = JSON.parse(this.actualRow);
    }

    onChangeSelect(event) {
        let value = event.target.value;
        console.log(value);
    }

    get_antecedentes(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_ant.numpermiso = id;
                this.temp_ant.tipo_permiso = this.rows[x].tipo_permiso;
                this.temp_ant.permiso = this.rows[x].permiso;
                this.temp_ant.numero = this.rows[x].numero;
                this.temp_ant.fecha = this.rows[x].fecha;
                this.temp_ant.superficie = this.rows[x].superficie;

                console.log(this.temp_ant);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_ant = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 };

    }

    saveAntecedentes() {
        var id = this.temp_ant.numpermiso;
        console.log(this.temp_ant)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("antecedentes", JSON.stringify(this.rows));

                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("antecedentes");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    tipo_permiso: this.temp_ant.tipo_permiso,
                    permiso: this.temp_ant.permiso,
                    numero: this.temp_ant.numero,
                    fecha: this.temp_ant.fecha,
                    superficie: this.temp_ant.superficie

                })
                localStorage.setItem("antecedentes", JSON.stringify(this.rows));
              /*   this.temp_ant.reset() */
                this.dialog.closeAll();
            }
        }
    }

    changeStatus(values, element, event) {
        /*   console.log(values)
          console.log(this.rows[element.id]) */
        this.rows[element.id].ckeck = values


        localStorage.setItem("docs_checkedOK", "cambiado")
        localStorage.setItem("docs_checked", JSON.stringify(this.rows))

    }

}